import { useIntl } from "react-intl"
import { useRef, useState } from "react"
import { Combobox, CustomTable, InputDate } from "medere-ui-framework"
import { Column } from "primereact/column"
import { format, parseISO } from 'date-fns';

import { getPatients, getPatientsList } from "../servicesHooks/Transfer/useTransferService"
import { useOperationRoomService } from "../servicesHooks/OperationRoom/useOperationRoomService"
import { useEntityService } from "../servicesHooks/Entity/useEntityService"

export default function OperationRoomStatisticsView() {
    const { getExcelDocument, getHospitalLocations, getSurgeryList } = useOperationRoomService();
    const { getProfessionals } = useEntityService();

    const intl = useIntl()
    const [selectedProfessional, setSelectedProfessional] = useState<any>(null)
    const [selectedSurgeryLocation, setSelectedSurgeryLocation] = useState<any>(null)
    const [selectedPatient, setSelectedPatient] = useState<any>(null)
    const queryRef: any = useRef(null)
    const [fromDate, setFromDate] = useState(generateFromDate())
    const [toDate, setToDate] = useState(generateToDate())
    const todayDate = new Date()

    function generateFromDate() {
        const currentDate = new Date();
        currentDate.setMonth(currentDate.getMonth() - 1); // Restar un mes
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1; // Los meses son base 0
        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDate = `${year}-${formattedMonth}-01T03:00:00.000Z`;

        return new Date(formattedDate);
    }

    function generateToDate() {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + 1); // Agregar un día

        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1; // Los meses son base 0
        const day = currentDate.getDate();

        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDay = day < 10 ? `0${day}` : day;

        const formattedDate = `${year}-${formattedMonth}-${formattedDay}T03:00:00.000Z`;

        return new Date(formattedDate);
    }

    return (
        <div className="px-4 flex flex-col viewContainer operation-room-statistics-view">
            <h2 className="text-2xl">Libro de quirófano</h2>
            <div className="flex md:gap-4 gap-2 align-items-end flex-column md:flex-row">
                <Combobox label={intl.formatMessage({ id: 'patient' })} getItems={getPatientsList} params={{ fromDate, toDate }} optionLabel='fullname' setValue={(value) => { setSelectedPatient(value); }} value={selectedPatient} className='' />
                <Combobox label={intl.formatMessage({ id: 'professional' })} getItems={getProfessionals} optionLabel='prefixAndFullName' setValue={setSelectedProfessional} value={selectedProfessional} />
                <Combobox label={intl.formatMessage({ id: 'surgerylocation' })} getItems={getHospitalLocations} optionLabel='description' setValue={setSelectedSurgeryLocation} value={selectedSurgeryLocation} />
                <InputDate label={intl.formatMessage({ id: 'from' })} value={fromDate} onChange={(e: any) => setFromDate(e.value)}
                    maxDate={todayDate} />
                <InputDate label={intl.formatMessage({ id: 'to' })} value={toDate} onChange={(e: any) => setToDate(e.value)} maxDate={todayDate} />
            </div>



            <CustomTable idTable="tableSurgeryList" getItems={getSurgeryList} showGridlines hideFiltersButton params={{
                patient: selectedPatient ? selectedPatient.medereentity : null,
                professional: selectedProfessional ? selectedProfessional.professional : null,
                surgerylocation: selectedSurgeryLocation ? selectedSurgeryLocation.hospitallocation : null,
                fromDate: fromDate,
                toDate: toDate,
            }} className='crudTable editable-cells-table operation-room-statistics-table' ref={queryRef}
                exportItems={[{ label: "Excel", icon: "pi-file-excel", onExport: getExcelDocument }]}>
                <Column field="dayofweekname" header={intl.formatMessage({id:'dayofweek'})} className="column"/>

                <Column field="servedtime" body={(x) => {
                    let formatted = '';
                    try {
                      if (x.servedtime && typeof x.servedtime === 'string' && !isNaN(Date.parse(x.servedtime))) {
                        const date = parseISO(x.servedtime);
                        if (!isNaN(date.getTime())) {
                          formatted = format(date, 'dd/MM/yyyy HH:mm');
                        }
                      }
                    } catch (_) {
                      formatted = '';
                    }
                    return formatted;                    
                }} header={intl.formatMessage({ id: 'hi' })} className="column" />
                <Column field="completedtime" body={(x) => {
                    try {
                        if (
                          x.completedtime &&
                          typeof x.completedtime === 'string' &&
                          !isNaN(Date.parse(x.completedtime))
                        ) {
                          const date = parseISO(x.completedtime);
                          if (!isNaN(date.getTime())) {
                            return format(date, 'dd/MM/yyyy HH:mm');
                          }
                        }
                      } catch (_) {}
                      return '';                      
                }} header={intl.formatMessage({ id: 'hf' })} className="column" />
                <Column field="fullname" header={intl.formatMessage({ id: 'patient' })} className="column" />
                <Column field="clinichistoryid" header={intl.formatMessage({ id: 'clinichistory' })} className="column" />
                <Column field="age" header={intl.formatMessage({ id: 'age' })} className="column" />
                <Column field="coverage" header={intl.formatMessage({ id: 'coverage' })} className="column" />
                <Column field="entityplan" header={intl.formatMessage({ id: 'entityplan' })} className="column" />
                <Column field="benefitnumber" header={intl.formatMessage({ id: 'benefitnumber' })} className="column" />
                <Column field="practicecode" header={intl.formatMessage({ id: 'practicecode' })} className="column" />
                <Column field="practice" header={intl.formatMessage({ id: 'practice' })} className="column" />
                <Column field="anesthesiologist" header={intl.formatMessage({ id: 'anesthesiologist' })} className="columnName" />
                <Column field="anaesthesiatype" header={intl.formatMessage({ id: 'anaesthesiatype' })} className="column" />
                <Column field="professional" header={intl.formatMessage({id:'professional'})} className="columnName"/>
                <Column field="firstassistant" header={intl.formatMessage({id:'firstassistant'})} className="columnName"/>
                <Column field="secondassistant" header={intl.formatMessage({id:'secondassistant'})} className="columnName"/>
                <Column field="thirdassistant" header={intl.formatMessage({id:'thirdassistant'})} className="columnName"/>
                <Column field="fourthassistant" header={intl.formatMessage({id:'fourthassistant'})} className="columnName"/>
                <Column field="instrumentator" header={intl.formatMessage({id:'instrumentator'})} className="columnName"/>
                <Column field="nurse" header={intl.formatMessage({id:'Nurse'})} className="columnName"/>
                <Column field="surgerytype" header={intl.formatMessage({id:'type'})} className="column"/>
                <Column field="surgeryoptions" header={intl.formatMessage({id:'Priority'})} className="column"
                    body={(recordData) => {
                        const surgeryOptions = recordData.surgeryoptions ? recordData.surgeryoptions.split(",") : [];
                        if (surgeryOptions.some((option: string) => option.toLowerCase() === "urgencia"))
                            return "URG";
                        else
                            return "PR";
                    }}
                />
                <Column field="sector" header={intl.formatMessage({ id: 'sector' })} className="column" />
                <Column field="surgerylocation" header={intl.formatMessage({ id: 'surgerylocation' })} className="column" />

            </CustomTable>
        </div>
    )
}
